import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Hourglass, X } from "lucide-react";

// Le mie iscrizioni in lista d'attesa (profilo assistito)
export const MyWaitlist = () => {
  const [entries, setEntries] = useState([]);
  const load = () => api.get("/user/waitlist").then((r) => setEntries((r.data.entries || []).filter((e) => e.status === "in_attesa"))).catch(() => {});
  useEffect(() => { load(); }, []);

  const leave = async (id) => {
    if (!window.confirm("Vuoi uscire dalla lista d'attesa per questo orario?")) return;
    await api.delete(`/user/waitlist/${id}`); load();
  };

  if (entries.length === 0) return null;
  return (
    <div className="mb-6" data-testid="my-waitlist">
      <h3 className="font-display text-xl mb-3 flex items-center gap-2"><Hourglass className="w-5 h-5 text-labor-terracotta" /> In lista d'attesa</h3>
      <div className="space-y-2">
        {entries.map((e) => (
          <div key={e.id} className="paper-card p-4 flex items-center gap-3 flex-wrap border-l-4 border-l-labor-warning" data-testid={`my-waitlist-${e.id}`}>
            <div className="font-display text-lg text-labor-terracotta">{e.slot_date} · {e.slot_time}</div>
            <div className="text-sm flex-1">{e.service_name}</div>
            <span className="text-xs text-labor-muted">Se si libera, il posto sarà assegnato a te in automatico</span>
            <button data-testid={`my-waitlist-leave-${e.id}`} onClick={() => leave(e.id)} className="text-xs text-red-600 border border-red-200 px-2 py-1 flex items-center gap-1 hover:bg-red-50"><X className="w-3 h-3" /> Esci</button>
          </div>
        ))}
      </div>
    </div>
  );
};
